import React from 'react';
import { Avatar } from '@mui/material';
import { getInitials } from '../../utils/userColors';

/**
 * Colored-initials avatar driven by the user's `color` field
 * (App Users module). Shared by Leads comments and the Tasks module.
 */
const UserAvatar = ({ name, color, size = 32, sx = {} }) => (
  <Avatar
    sx={{
      width: size,
      height: size,
      bgcolor: color || '#9e9e9e',
      color: '#fff',
      fontSize: size * 0.4,
      fontWeight: 600,
      ...sx
    }}
  >
    {getInitials(name)}
  </Avatar>
);

export default UserAvatar;
